var exports = {
  "mj": "xaee3c4fa--f82999--like",
  "Ui": "xaee3c4fa--f82999--like__title",
  "Mc": "xaee3c4fa--f82999--like__button-wrapper",
  "wd": "xaee3c4fa--f82999--like__button",
  "iJ": "xaee3c4fa--f82999--like__button__check",
  "au": "xaee3c4fa--f82999--like__button-text",
};

module.exports = exports;
